
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  font-family:var(--ff-dmsans);
  -webkit-font-smoothing:antialiased;
  display:flex;
  flex-direction:column;
}

.basic-card{
  display:flex;
  flex-direction:column;
  background:var(--neutral-white);
  color:var(--brand-neutral-gray-800);
  text-decoration:none;
  margin-bottom:var(--spacing-4);
  flex:1;
}

.basic-card__image{
    width:100%;
    max-height:250px;
    overflow:hidden;
  }

.basic-card__image img{
      width:100%;
      object-fit:cover;
      transition:1s;
    }

.basic-card__image{
    aspect-ratio:4/3;
}

@media (min-width: 768px){

.basic-card__image{
      aspect-ratio:16/9
  }
    }

.basic-card__content{
    width:100%;
    padding:1rem 1rem 1.25rem;
    display:flex;
    flex-direction:column;
    gap:1rem;
  }

.basic-card__body-text{
    font-size:var(--fs-base);
    font-weight:var(--fw-normal);
    margin:0;
  }

.basic-card__link{
    display:inline-flex;
    flex-direction:column;
    margin:0;
    font-size:var(--fs-lg);
    font-weight:var(--fw-bold);
  }

.basic-card.hover-img:hover{
    cursor:pointer;
  }

.basic-card.hover-img:hover img{
      transform:scale(1.1);
      transition:1s;
    }

.basic-card--white .basic-card__link, .basic-card--location .basic-card__link{
      color:var(--brand-neutral-gray-800);
    }

.basic-card--white:hover, .basic-card--location:hover{
      background:var(--brand-primary-3);
    }

.basic-card--green{
    background:var(--brand-secondary-4);
  }

.basic-card--green a{
      color:black !important;
    }

.basic-card--green:hover{
      background:var(--brand-primary-1);
      color:var(--neutral-white);
    }

.basic-card--no-link:not(.basic-card--location):hover{
      cursor:auto;
      background:var(--neutral-white);
    }

.basic-card--no-link:not(.basic-card--location):hover.basic-card--green{
        background:var(--brand-secondary-4);
        color:var(--brand-neutral-gray-800);
      }

.basic-card--basic .basic-card__link{
      padding:var(--spacing-4);
    }

@media (min-width: 768px){
      .basic-card--basic .basic-card__link{
        padding-top:var(--spacing-6);
      }
    }
`;